import { Types } from './actions';

export const INITIAL_STATE = '';

export default function home(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case Types.OPEN_MODAL:
      return action.payload;
    case Types.CLOSE_MODAL:
      return '';
    default:
      return state;
  }
}
